import styled from '@emotion/styled';

const Container = styled.div`
  position: absolute;
  left: 50%;
  right: 50%;
  top: 0;
  bottom: 0;
`;

const SmallDot = styled.div`
  width: 4px;
  height: 4px;
  border-radius: 50%;
  background-color: #dadeed;
`;

const BigDot = styled.div`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: #c2c7d4;
  transform: translate(-25%, -35%);
`;

type Props = {
  angle: number;
  big: boolean;
};

export const Dot = ({ angle, big = false }: Props) => (
  <Container style={{ transform: `rotate(${angle}deg)` }}>
    {big ? <BigDot /> : <SmallDot />}
  </Container>
);
